import React from 'react';

import CloseButton from './CloseButton';

import styles from './Popup.module.scss';

interface Props {
  className?: string;
  children?: any;
  width?: string;
  height?: string;
  closable?: boolean;
  darkenBg?: boolean;

  close?(): void;
}

const Popup = ({
  className,
  width,
  height,
  closable,
  darkenBg,
  close,
  children,
}: Props) => {
  let popupContainerClassName = `${className} ${styles.popup__container}`;
  if (darkenBg) popupContainerClassName += ` ${styles.popup__container__dark}`;

  return (
    <div className={popupContainerClassName}>
      <div
        className={`${className} ${styles.popup}`}
        style={{
          width,
          height,
          ...(darkenBg
            ? {}
            : { boxShadow: '0 0 5px 3px #aaaaaa40', border: 'none' }),
        }}
      >
        {closable && <CloseButton onClose={close} />}
        {children}
      </div>
    </div>
  );
};

Popup.defaultProps = {
  className: '',
  children: [],
  width: '420px',
  height: 'auto',
  closable: false,
  darkenBg: false,
  close: () => {},
};

export default Popup;
